import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import Button from '@atlaskit/button'
import { AccessStatusIndicator, ModalDialog } from '../components/index'
import { triggerAccessBot, getUserAccessStatus, clearAccessBotResults, clearUserStatus } from './actions'
import { selectAccessStatus, selectAccessBotResults } from './reducer'
import { selectIsRequestPending } from '../util/index'
import { Spinner, Link, H3, InfoTooltip } from '../components/index.js'
import RefreshIcon from '@atlaskit/icon/glyph/refresh'

export class AccessStatus extends Component {        
    componentWillMount () {
        let { username, getUserAccessStatus, clearUserStatus } = this.props
        clearUserStatus()
        if (username) {
          getUserAccessStatus(username).catch(err => console.error(err))
        }        
      }
      
      handleClick = (app) => {
        let { username, triggerAccessBot } = this.props
        triggerAccessBot(username, app)
      }

      handleRefresh = () => {
        let {getUserAccessStatus, username} = this.props
        getUserAccessStatus(username)
      }
      
      render () {
        let { getAccessPending,
            updateAccessPending,
            botResults,
            clearAccessBotResults,
            accessStatus,
            title,
            header,
        } = this.props        
        let appList = null
        if (accessStatus && !getAccessPending) {
            appList = accessStatus.map((app) => {
                return (
                    <div key={app.name}>
                        <span className='access-status-container'>
                            <Link external={true} to={app.url} className='access-status-app link'>{app.name}</Link>
                            <AccessStatusIndicator 
                                className='access-status-indicator' 
                                status={app.status.toLowerCase()}>
                                {
                                    app.status=='ACTIVE' ? 'Access verified' :
                                    app.status=='UNAVAILABLE' ? 'Tool is currently unavailable' :
                                    app.status=='INPROGRESS' ? 'Request Processing, pending app sync to complete' 
                                        : 'Click "Grant Access" to get access to the application.' }
                            </AccessStatusIndicator>
                            {
                                app.status=='INACTIVE' ? 
                                <Button
                                    className='access-status-button' 
                                    type='button' 
                                    appearance='primary' 
                                    //isLoading={getAccessPending || updateAccessPending}
                                    spacing="compact" 
                                    onClick={() => this.handleClick(app.app)}>Grant Access
                                </Button> : null
                            }
                        </span>
                    </div>
                )
            })
        }
        
        return (
            <div>
                
                {
                    header ? <H3 className='pb5-sm'>{header}
                        <InfoTooltip key='tooltip' className='ml2-sm'>Status of your application level access to the listed tools</InfoTooltip>
                        {!getAccessPending ? <button className='btn icon-solo' title='refresh' onClick={this.handleRefresh}><RefreshIcon size='medium' /></button> : null}
                        </H3> : 
                    title ? <div className='section-header' >{title}
                            {!getAccessPending ? <button className='btn icon-solo' title='refresh' onClick={this.handleRefresh}><RefreshIcon size='small' /></button> : null}
                        </div> : null                                        
                }
                {
                    appList && !updateAccessPending ? appList : <Spinner medium />
                }
                {
                    botResults ? <ModalDialog display={true} handleClose={clearAccessBotResults}>{botResults}</ModalDialog> : null
                }
            </div>
            
        )
      }
}

export default withRouter(connect((state) => {
    return {
        updateAccessPending: selectIsRequestPending(state, triggerAccessBot),
        getAccessPending: selectIsRequestPending(state, getUserAccessStatus),
        accessStatus: selectAccessStatus(state),
        botResults: selectAccessBotResults(state),        
    }
}, { getUserAccessStatus, triggerAccessBot, clearAccessBotResults, clearUserStatus })(AccessStatus))


// WEBPACK FOOTER //
// ./client/src/accessSelfService/AccessStatus.js